import { ExportStatus } from './common.js';

export const Kind = 'EXPORT_MEDICATIONS' as const;
export { ExportStatus as Status };
